/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import Axios from "axios";

import { config } from "../config";
import { getToken } from "../auth/msal";
import { v4 as uuidv4 } from "uuid";
import axiosRetry from "axios-retry";

const axiosInstance = Axios.create({
  baseURL: config.api.baseUrl,
});

axiosRetry(axiosInstance, {
  retries: config.api.retryCount,
  retryDelay: axiosRetry.exponentialDelay,
});

axiosInstance.interceptors.request.use(
  (axiosConfig) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (axiosConfig.headers) {
          axiosConfig.headers.Authorization = "Bearer " + (await getToken());
          axiosConfig.headers["X-SubCorrelationId"] = uuidv4();
        }
        resolve(axiosConfig);
      } catch (error) {
        reject(axiosConfig);
      }
    });
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axiosInstance;
